<template>
  <b-card id="card-303" class="card border-0 stand-up-animation animation-shadow shadow rounded img-object-fit"
          :img-src="image" :img-alt="alt" img-top>
    <b-row>
      <b-col>
        <slot></slot>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: "C303",
  props: {
    image: {
      default: 'https://picsum.photos/1280/720'
    },
    alt: {
      default:'mix it web'
    }
  }
}
</script>

<style>
#card-303 img {
  object-fit: cover;
  height: 250px;
}
</style>

<style scoped>
.card .card-img-top {
  border-radius: 15px 15px 0 0;
}

.card {
  height: 100% !important;
  cursor: pointer;
  border-radius: 15px 15px 0 0 !important;
  border: none;
}

.stand-up-animation {
  transform: translateY(0px);
  transition: all 0.3s ease 0s;
}

.stand-up-animation:hover {
  transform: translateY(-7px);
  transition: all 0.3s ease 0s;
}

.animation-shadow:hover {
  box-shadow: 10px 10px 10px rgba(180, 210, 198, 0.4);
}

</style>

